/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// show back order option
$(document).ready(function() {
  var handler = $(".ProductForm__Option--labelled .HorizontalList__Item");
  // Event hanedler
handler.each(function(){
  $(this).click(function(){
window.setTimeout(()=>{
  var varid = window.location.href.split('variant='); 
  var isbackorder = $('[data-or-var-id='+ varid[1] +']').attr('data-backorder')
  if(isbackorder == "true"){
 
    $('.backorder-note').removeClass('hide')
  }else{
    
    $('.backorder-note').addClass('hide')
  }
},500)
  })
})
  // on doc load 
  var selectedVariId = $('.no-js.ProductForm__Option select option:selected').val();
  var checkIsBackOrder =  $('[data-or-var-id='+ selectedVariId +']').attr('data-backorder')
    if(checkIsBackOrder == "true"){
 
    $('.backorder-note').removeClass('hide')
  }else{
    
    $('.backorder-note').addClass('hide')
  }
  // show not available text if variant not avalable
   var varMatchWindow = window.location.href.split('variant='); 
  var varMatch = varMatchWindow[1]
  var items = document.querySelectorAll('.product-accordion-inner .HorizontalList__Item input');
  items.forEach((item)=>{
item.addEventListener('click',(e)=>{
  console.log('target',e.target)
    setTimeout(() => {
var atc = document.querySelector('.ProductForm__BuyButtons');
      const atcCompStyles = window.getComputedStyle(atc);
      if(atcCompStyles.display == 'none'){
        
        console.log(document.querySelector('.not-available'))
        document.querySelector('.not-available').innerHTML = '<span>Not Available</span>';
        console.log(document.querySelector('.not-available'))
      $('.not-available').html('<span>Not Available</span>')
      }else{
        // alert(atcCompStyles.display)
        $('.not-available').html('')
      }
      
    }, 300);
})
  })

// Read more button logic 
  $('.moreless-button').click(function() {
    $('.moretext').slideToggle();
    console.log($(this).text());
    if ($(this).text() == "Read More") {
      $(this).text("Read less");
    } else {
      $(this).text("Read More");
    }
});



  
});
// end back order option
$('.accordiont').find('.prod-title-bar').click(function(){
  // modified from union deisgn+code at http://uniondesign.ca/simple-accordion-without-jquery-ui/
  // mc 4/2/2015
  //Expand or collapse this panel
//   $(".ProductForm__Variants input[name='id']").attr("value",$(this).attr('varid'));

  var isActive = $(this).hasClass("active");
  $('.prod-title-bar').removeClass('active');
  if (!isActive) {
    $(this).toggleClass('active');
  }

  $(this).next().slideToggle('fast');     
  //Hide the other panels
  $(".prod-content-section").not($(this).next()).slideUp('fast');
  // $(".prod-content-section").not($(this)).toggleClass('active');
  // $(this).toggleClass('active');

});
$('.prod-id-1').find('.prod-title-bar').click(function(){
	$(".main-cart").hide();
  	$(".cst-cart").show();
  	$(".ProductMeta__PriceList").hide();
  	$(".send_price").show();  
 	$(".send_price .cst_price").text($(this).attr('price'));
});
$('.prod-id-2').find('.prod-title-bar').click(function(){
	$(".cst-cart").hide();
    $(".main-cart").show();    
    $(".send_price").hide();
    $(".ProductMeta__PriceList").show();
    $("#child-product-select").val("");
});

$("#child-product-select").change(function(){
//   $(".ProductForm__Variants input[name='id']").attr("value",$(this).val());
     var optionSelectedprice = $("option:selected", this).attr("price");
  $(".send_price .cst_price").text(optionSelectedprice);
});
// var e =

$('.cst-cart').click(function(){
var var_id = $("#child-product-select").val();
  var qty = $('.QuantitySelector').find('[name="quantity"]').val();
  var t = $('.ProductForm').offset();
  $('<div class="webyze-ilpo-loading"></div>').appendTo("body").css({
    width: $('.ProductForm').outerWidth() + "px",
    height: $('.ProductForm').outerHeight() + "px",
    top: t.top - parseInt($("html").css("padding-top")) - ("relative" == $("body").css("position") ? parseInt($("body").offset().top) + parseInt($("body").css("border-top-width")) : 0) + "px",
    left: t.left + "px"
  })
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
      quantity: qty,
      id: var_id,
    },
    success: function(){
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
        }
      ));
      document.documentElement.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,  //this code is for prestige theme, is to refresh the cart
          detail: {
            variant: var_id,
            quantity: 1
          }
        }
      ));
      $('.cart_open').trigger("click");
      document.addEventListener('product:added', this._onProductAddedListener);
      $(".webyze-ilpo-loading").remove();
    },
    error: function(){}
  });
  
});